<template>
  <v-dialog
    :value="open"
    max-width="460"
    overlay-color="neutral lighten-1"
    overlay-opacity=".80"
    content-class="qr-dialog"
    scrollable
    @input="cancel"
  >
    <v-card rounded class="pa-6">
      <!-- Title -->
      <v-card-title class="px-0 pt-0">
        <h4 class="text-h4">
          <span>
            {{ $t('fields.account.billing.reactivate_subs.modal_title') }}
          </span>
        </h4>
      </v-card-title>

      <!-- Subtitle description -->
      <v-card-subtitle class="px-0 pt-3 pb-5">
        <span v-html="$t('fields.account.billing.reactivate_subs.modal_desc', { date: renew })" />
      </v-card-subtitle>

      <!-- Actions -->
      <v-card-actions class="px-0 py-0 mt-3">
        <v-spacer />
        <v-btn
          outlined
          large
          :ripple="false"
          rounded
          color="primary"
          :disabled="showLoadingSubscription.reactivateSubscription"
          @click="cancel"
        >
          <span>
            {{ $t('fields.account.billing.reactivate_subs.modal_btn_outline') }}
          </span>
        </v-btn>
        <v-btn
          depressed
          large
          :ripple="false"
          rounded
          color="primary"
          class="ml-4"
          :loading="showLoadingSubscription.reactivateSubscription"
          :disabled="showLoadingSubscription.reactivateSubscription"
          @click="onReactivateSubscription(activeSubscription.plan_id)"
        >
          <span>
            {{ $t('fields.account.billing.reactivate_subs.modal_btn_primary') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import store from '@/store';
import { SubscriptionState } from '@/classes/stripe';
import OptimizelyService from '@/Services/OptimizelyService';
import { trackUndoCancellationKeepSubscriptionButtonClicked } from '@/Services/Snowplow/SnowplowService';

@Component({
  computed: {
    ...mapState<SubscriptionState>('subscription', {
      showLoadingSubscription: (state: SubscriptionState) => state.showLoading,
    }),
  },
})
export default class ReactivateSubscription extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop()
  renew!: string;

  showLoadingSubscription!: any;
  activeSubscription = store.state.subscription.activeSubscription;

  onReactivateSubscription(planId: string): void {
    OptimizelyService.trackEvent('checkout_renewal_modal_enable');

    // ENG-2317: Track Subscription Reactivation [undo_cancellation.keep_subscription_button.clicked]
    trackUndoCancellationKeepSubscriptionButtonClicked({
      industry_id: store.state?.account?.account?.industry_id ?? null,
      user_id: store.state?.auth?.user?.id,
    });

    if (!this.activeSubscription.id) {
      return;
    }

    store
      .dispatch('subscription/reactivateSubscription', planId)
      .then(() => {
        store.dispatch('subscription/setActiveSubscription', this.activeSubscription);
        this.$emit('reactivate');
        this.$emit('cancel');
      })
      .catch(() => {
        this.$emit('cancel');
        store.dispatch('layout/setSnackbar', {
          type: 'error',
          icon: 'forbidden-system',
          text: this.$t('fields.account.billing.reactivate_subs.snackbar_error').toString(),
          isSnackbar: true,
          active: true,
        });
      });
  }

  cancel(): void {
    OptimizelyService.trackEvent('checkout_renewal_modal_cancel');
    this.$emit('cancel');
  }
}
</script>
